import styles from './UnknownQuestionAnswerEditor.module.css'

export interface UnknownQuestionAnswerEditorProps {
  type: string
}

export function UnknownQuestionAnswerEditor({
  type,
}: UnknownQuestionAnswerEditorProps) {
  return (
    <div className={styles.root}>
      Unknown question type "{type.replace('_', ' ').toLowerCase()}" — hey,
      can't win them all ¯\_(ツ)_/¯
    </div>
  )
}
